/**
 * @desc 编辑历史sku信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmSkuEditHistoryRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/editHistorySku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
